import React, { useContext } from 'react';
import { styled } from '@mui/material';
import { IBooking } from '../Utils/EDCalendarViewUtils';
import { EDCalendarViewDayViewBooking } from './EDCalendarViewDayViewBooking';
import EDBox from '../../EDBox/EDBox';
import { EDStickyTableContext } from '../../StickyTable/Contexts/EDStickyTableContext';
import EDIcon from '../../Icon/EDIcon';
import { ViewDbSettingsContext } from '../../../Features/Delsystem/Bokning/Rutiner/Kalender/Components/SchedulerComponent/ViewDbSettingsContext';
import EDTooltip from '../../Tooltip/EDTooltip';
interface IProps {
  bookings: IBooking[];
  onBookingClick?: (ref: EventTarget, booking: IBooking) => void;
  view: 'List' | 'All';
}

const splitBookings = (
  bookings: IBooking[],
  bookingHeight: number,
  responsiveHeight: number,
  iconHeight: number
): { fitBookings: IBooking[]; overflowBookings: IBooking[] } => {
  if (!bookings?.length) {
    return { fitBookings: [], overflowBookings: [] };
  }

  let availableHeight = responsiveHeight;
  let fitCount = 0;
  const totalBookingsHeight = bookings?.length * bookingHeight;

  if (totalBookingsHeight <= responsiveHeight) {
    return {
      fitBookings: [...bookings],
      overflowBookings: [],
    };
  }

  availableHeight -= iconHeight;
  fitCount = Math.floor(availableHeight / bookingHeight);
  const fitBookings = bookings.slice(0, fitCount);
  const overflowBookings = bookings.slice(fitCount);

  return { fitBookings, overflowBookings };
};

export const EDCalendarViewDayViewBookings: React.FC<IProps> = props => {
  const stickyTableContext = useContext(EDStickyTableContext);
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const currentView = viewDbSettingsContext.currentView;
  const dayContainerHeaderHeight = 20;

  const { fitBookings, overflowBookings } = splitBookings(
    props.bookings,
    24,
    currentView === 'Month2'
      ? stickyTableContext.responsiveRowHeight - dayContainerHeaderHeight
      : stickyTableContext.responsiveRowHeight,
    24
  );

  const handleClick = (aktStartTime: Date | undefined) => {
    viewDbSettingsContext.setCurrentView('Day2');
    if (aktStartTime) {
      viewDbSettingsContext.setCurrentDate(aktStartTime);
    }
  };

  return (
    <BookingsContainer>
      {fitBookings?.map((booking, index) => {
        return (
          <>
            <EDCalendarViewDayViewBooking
              key={index}
              booking={booking}
              onBookingClick={props.onBookingClick}
              view={props.view}
            />
            {overflowBookings.length > 0 && (
              <AdditionalBookingsContainer>
                <EDTooltip title={`Se fler (+${overflowBookings.length})`}>
                  <EDBox
                    onClick={() => {
                      handleClick(props.bookings?.[index]?.aktStartTime);
                    }}
                  >
                    <ThreePointerIcon iconType="more_horiz" />
                  </EDBox>
                </EDTooltip>
              </AdditionalBookingsContainer>
            )}
          </>
        );
      })}
    </BookingsContainer>
  );
};
const BookingsContainer = styled(EDBox, { name: 'BookingsContainer' })(
  ({ theme }) => ({
    margin: theme.spacing(0.25),
    overflow: 'hidden',
    height: '100%',
  })
);

const AdditionalBookingsContainer = styled(EDBox, {
  name: 'AdditionalBookingsContainer',
})(({ theme }) => ({
  display: 'flex',
  backgroundColor: 'white',
  position: 'absolute',
  bottom: '0px',
  right: '0px',
  borderLeft: `${theme.spacing(0.5)} solid var(--borderColor)`,
  paddingLeft: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  marginBottom: theme.spacing(0.125),
  height: '15px',
  width: '100%',
}));

const ThreePointerIcon = styled(EDIcon, {
  name: 'ThreePointerIcon',
})(() => ({
  cursor: 'pointer',
}));
